import { twMerge } from 'tailwind-merge';
import Title from '@/components/Title';
import { ListIcon } from '@/icons';
import Card from '@/components/Card';
import { formatNumber } from '@/utils/strings';
import { classes } from '../utils';

export type InvestmentsCardProps = {
  className?: string;
  count: number;
};

export default function InvestmentsCard({
  className,
  count,
}: InvestmentsCardProps) {
  return (
    <Card className={twMerge(classes.card, className)}>
      <div className={classes.textWrapper}>
        <div className={classes.label}>Investments</div>
        <Title size="md">{formatNumber(count)}</Title>
      </div>
      <div className={twMerge(classes.icon, classes.investmentsIcon)}>
        <ListIcon />
      </div>
    </Card>
  );
}
